import { UserForegroundDomainEnum } from './user-foreground-domain-enum'
import { ReviewResultEnum } from './review-result-enum'

export interface PaperReviewLogInterface {
  /**
   * 分配试卷id
   */
  paperId: number
  /**
   * 所属批阅人
   */
  reviewerId?: number
  /**
   * 主键 ID
   */
  id: number
  /**
   * 学校 ID
   */
  schoolId: number
  /**
   * 创建时间
   */
  createdAt: string
  /**
   * 更新时间
   */
  updatedAt: string
  questionId: number
  /**
   * 答案 ID
   */
  answerId: number
  /**
   * 答题人id
   */
  submitterId?: number
  submitterDomain: UserForegroundDomainEnum
  /**
   * 批改结果
   */
  result?: ReviewResultEnum | null
  /**
   * 得分
   */
  gainedScore?: string | null
  /**
   * 评语内容
   */
  content?: string
  /**
   * 附件
   */
  attachments?: object[]
  /**
   * 是否发布
   */
  isPublished?: boolean
}

export class PaperReviewLog implements PaperReviewLogInterface {
  /**
   * 分配试卷id
   */
  paperId: number
  /**
   * 所属批阅人
   */
  reviewerId?: number
  /**
   * 主键 ID
   */
  id: number
  /**
   * 学校 ID
   */
  schoolId: number
  /**
   * 创建时间
   */
  createdAt: string
  /**
   * 更新时间
   */
  updatedAt: string
  questionId: number
  /**
   * 答案 ID
   */
  answerId: number
  /**
   * 答题人id
   */
  submitterId?: number
  submitterDomain: UserForegroundDomainEnum
  /**
   * 批改结果
   */
  result?: ReviewResultEnum | null
  /**
   * 得分
   */
  gainedScore?: string | null
  /**
   * 评语内容
   */
  content?: string
  /**
   * 附件
   */
  attachments?: object[]
  /**
   * 是否发布
   */
  isPublished?: boolean

  constructor(props: PaperReviewLogInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      paperId: _paperId,
      reviewerId: _reviewerId,
      id: _id,
      schoolId: _schoolId,
      createdAt: _createdAt,
      updatedAt: _updatedAt,
      questionId: _questionId,
      answerId: _answerId,
      submitterId: _submitterId,
      submitterDomain: _submitterDomain,
      result: _result,
      gainedScore: _gainedScore,
      content: _content,
      attachments: _attachments,
      isPublished: _isPublished,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.paperId = _paperId
    this.reviewerId = _reviewerId
    this.id = _id
    this.schoolId = _schoolId
    this.createdAt = _createdAt
    this.updatedAt = _updatedAt
    this.questionId = _questionId
    this.answerId = _answerId
    this.submitterId = _submitterId
    this.submitterDomain = _submitterDomain
    this.result = _result
    this.gainedScore = _gainedScore
    this.content = _content
    this.attachments = _attachments
    this.isPublished = _isPublished
  }
}
